import Product from "./product.container";

export default Product;
